export default function () {
	const debug = false;
	const popUpModal = $('.popup-modal');

	function popupCookie() {
		setCookie('popup_cookie', 'hide', 1); // Set to 1 day
	}

	function popupDismiss() {
		popUpModal.removeClass('active');

		setTimeout(function() {
			$(this).remove(); // give it a chance to fade out before destroying
		}, 1000); // 1000 = 1s
	}


	// Destroy the pop-up if they've already got the cookie
	if (getCookie('popup_cookie') === 'hide') {
		debug ? console.log('pop-up cookie found, deleting HTML element') : false;
		popUpModal.remove();
	} else {
		debug ? console.log('pop-up cookie not found') : false;
		popUp();
	}

	// the pop-up
	function popUp() {
		debug ? console.log('showing pop-up and waiting for the next step') : false;

		// fade the popup in after 3 seconds
		setTimeout(function() {
			debug ? console.log('adding .active to the pop-up') : false;
			popUpModal.removeAttr('style');
			popUpModal.addClass('active');
		}, 3000); // 3000 = 3s

		// close pop-up
		$('#popup-modal .popup-modal__close').on('click', function(e) {
			debug ? console.log('pop-up close button clicked') : false;
			e.preventDefault();

			popupDismiss();
			popupCookie();
		});

		$('#popup-modal .popup-modal__button').on('click', function(e) {
			debug ? console.log('pop-up cta button clicked') : false;

			popupDismiss();
			popupCookie();
		});
	}

	// Retrieves cookie value
	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	// Creates cookies
	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires=" + d.toGMTString();
		document.cookie = cname + "=" + cvalue + "; " + expires;
	}
}
